import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enTrademark from './locales/en/trademark.json';
import enPayment from './locales/en/payment.json';
import enAttorney from './locales/en/attorney.json';
import enNotifications from './locales/en/notifications.json';

import esCommon from './locales/es/common.json';
import esDashboard from './locales/es/dashboard.json';
import esTrademark from './locales/es/trademark.json';
import esPayment from './locales/es/payment.json';
import esAttorney from './locales/es/attorney.json';
import esNotifications from './locales/es/notifications.json';

import deCommon from './locales/de/common.json';
import deDashboard from './locales/de/dashboard.json';
import deTrademark from './locales/de/trademark.json';
import dePayment from './locales/de/payment.json';
import deAttorney from './locales/de/attorney.json';
import deNotifications from './locales/de/notifications.json';

import zhCommon from './locales/zh/common.json';
import zhDashboard from './locales/zh/dashboard.json';
import zhTrademark from './locales/zh/trademark.json';
import zhPayment from './locales/zh/payment.json';
import zhAttorney from './locales/zh/attorney.json';
import zhNotifications from './locales/zh/notifications.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        dashboard: enDashboard,
        trademark: enTrademark,
        payment: enPayment,
        attorney: enAttorney,
        notifications: enNotifications,
      },
      es: {
        common: esCommon,
        dashboard: esDashboard,
        trademark: esTrademark,
        payment: esPayment,
        attorney: esAttorney,
        notifications: esNotifications,
      },
      de: {
        common: deCommon,
        dashboard: deDashboard,
        trademark: deTrademark,
        payment: dePayment,
        attorney: deAttorney,
        notifications: deNotifications,
      },
      zh: {
        common: zhCommon,
        dashboard: zhDashboard,
        trademark: zhTrademark,
        payment: zhPayment,
        attorney: zhAttorney,
        notifications: zhNotifications,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
